import waitFor from '@iez/lib/wait-for/'
import user from '@iez/lib/user/'
import data from '@iez/lib/data/'

export default [{
  name: `Onboarding`,
  isResolvedSync: () =>
    localStorage.getItem(`onboarding`)
}, {
  name: `Authentication-PhoneNumber`,
  isResolvedAsync: async () => {
    await waitFor({
      dependencies: () => user.isReady
    })
    return !!user.id
  },
  isAllowed: route => route.name.startsWith(`Authentication`),
  ignoreIfResolved: true,
  shouldStartAt: `Onboarding`
}, {
  name: `ProfileEdit`,
  isResolvedAsync: async () => {
    const me = data.me({
      fields: [
        `id`,
        `name`
      ],
      isCalledFromComponent: false,
      realtime: () => !me.value?.id
    })
    await waitFor({
      dependencies: () => me.value?.id
    })
    me.value.$clean()
    return !!me.value.name
  },
  isAllowed: route => route.name === `InputImage`
}]
